import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { useScheduledBroadcast } from '../state/scheduleState';
import { copy } from '../utils';
import { getStreamUrl } from '../utils/url';
import { Button } from './Button';
import { LargeCopyIcon, OrangeCameraIcon, InfoIcon as PrestyledInfoIcon, } from './Icon';
export function BroadcastNameplate({ onGoLiveClick, streamId, }) {
    const broadcast = useScheduledBroadcast(streamId);
    const url = getStreamUrl(streamId, {
        broadcastTitle: broadcast?.name,
        broadcastStartsAt: broadcast?.startsAt,
    });
    return (_jsxs(BroadcastNameplateRoot, { children: [_jsxs(Segment, { children: [_jsx(Url, { children: url.replace(/^https?:\/\//, '') }), _jsx(CopyButton, { type: "button", onClick: () => {
                            copy(url);
                        }, children: _jsx(LargeCopyIcon, {}) })] }), _jsxs(DisclaimerSegment, { children: [_jsx(InfoIcon, {}), _jsx(Disclaimer, { children: "Anyone who has this link can watch your live stream." })] }), !!onGoLiveClick && (_jsx(Segment, { children: _jsx(GoLiveButton, { type: "button", icon: _jsx(OrangeCameraIcon, {}), size: "mini", onClick: onGoLiveClick, children: "Go live" }) }))] }));
}
const GoLiveButton = styled(Button) `
    border-radius: 0.5rem;
    width: 100%;
`;
const InfoIcon = styled(PrestyledInfoIcon) `
    flex-shrink: 0;
`;
const Disclaimer = styled.div `
    font-size: 0.875rem;
    line-height: 1.25rem;
`;
const CopyButton = styled.button `
    align-items: center;
    appearance: none;
    background: none;
    border: 0;
    color: inherit;
    display: flex;
    flex-shrink: 0;
    font: inherit;
    justify-content: center;
    padding: 0;

    &:active {
        transform: translateY(0.0625rem);
    }
`;
const Url = styled.div `
    flex: 1;
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.25rem;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
const Segment = styled.div `
    align-items: center;
    background-color: rgba(53, 54, 49, 0.55);
    box-sizing: border-box;
    display: flex;
    gap: 1rem;
    min-height: 1.25rem;
    padding: 1rem;
`;
const DisclaimerSegment = styled(Segment) `
    border-top: 0.0625rem solid rgba(222, 222, 222, 0.2);
    gap: 0.625rem;

    & + ${Segment} {
        padding-top: 0;
    }
`;
const BroadcastNameplateRoot = styled.div `
    border-radius: 1rem;
    color: #ffffff;
    overflow: hidden;
`;
